module.exports = __webpack_public_path__ + "static/media/s_v9_t10_1.3d5dedb6.mp3";